import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { DefaultResponseWithData } from "../models/system";
import { ILead } from "../models/Lead";
import apiConfig from "../utils/apiConfig";

export default function useAccountLeads(accountId?: string, componentName = "useAccountLeads") {
  const { get } = useApiHelper(apiConfig(componentName));

  const accountLeads = useQuery({
    queryKey: ["accounts", accountId, "leads"],
    queryFn: () =>
      get<DefaultResponseWithData<ILead[]>>(
        `/account/${accountId}/leads`
      ),
    enabled: !!accountId,
  });

  return {
    accountLeads,
  };
}
